export function getCurrentHostname() {
  if (typeof window === 'undefined') {
    return '';
  }

  return (window.location.hostname || '').trim().toLowerCase();
}
